/** @format */

import {platformsFromAdType} from 'helpers/adTypeHelpers';
import {OauthProvider} from 'graphql/generated/types';

const getAdType = (providerType: OauthProvider | null) => {
  if (!providerType) {
    return 'CONTEXT';
  }

  const isContextConnected = platformsFromAdType('CONTEXT').includes(providerType);
  const isTargetConnected = platformsFromAdType('TARGET').includes(providerType);

  let adType = isContextConnected ? 'CONTEXT' : '';
  if (isTargetConnected) {
    adType = 'TARGET';
  }

  return adType;
};

export {getAdType};
